import { render, staticRenderFns } from "./DetailSideBar.vue?vue&type=template&id=e7d9a124&"
import script from "./DetailSideBar.vue?vue&type=script&lang=js&"
export * from "./DetailSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports